module.exports = __webpack_public_path__ + "img/JustMusic.458284d7.jpg";